/** 龙头传播里跟龙头走的本地保存。换日不删，只有退池才清。接力 TOP 池除外，按查看日分开存。 */

function normCode6(code) {
  return String(code || '')
    .trim()
    .split('.')[0]
    .replace(/\D/g, '')
    .padStart(6, '0')
    .slice(-6)
}

const PREFIX = {
  mainAttr: 'lcc.themeProp.mainAttr.v1',
  buZhang: 'lcc.themeProp.buZhang.v1',
  fbLeader: 'lcc.themeProp.fbLeader.v1',
  height: 'lcc.themeProp.heightManual.v3',
  heightV2: 'lcc.themeProp.heightManual.v2',
  heightV1: 'lcc.themeProp.heightManual.v1',
  relay: 'lcc.themeProp.relayTop.v2',
  relayV3: 'lcc.themeProp.relayTop.v3',
  relayV1: 'lcc.themeProp.relayTop.v1',
  fbSub: 'lcc.themeProp.fbSub.v1',
  fbConcepts: 'lcc.themeProp.fbConcepts.v1',
  fbPreselect: 'lcc.themeProp.fbPreselect.v1',
  fbPreselectChi: 'lcc.themeProp.fbPreselectChi.v1'
}

export function themePropCode(code) {
  const c = normCode6(code)
  if (!c || c === '000000') return ''
  return c
}

/** 从所有日期的接力 TOP 名单里拿掉这只股票。切换页按这份名单隐藏。 */
export function removeCodeFromAllRelayPools(code) {
  const c = themePropCode(code)
  if (!c || typeof localStorage === 'undefined') return
  const prefix = `${PREFIX.relayV3}|`
  const keys = []
  try {
    for (let i = 0; i < localStorage.length; i += 1) {
      const k = localStorage.key(i)
      if (k && k.indexOf(prefix) === 0) keys.push(k)
    }
    keys.forEach((k) => {
      const rows = JSON.parse(localStorage.getItem(k) || '[]')
      if (!Array.isArray(rows) || !rows.length) return
      const next = rows.filter((row) => themePropCode(row && row.code) !== c)
      if (next.length !== rows.length) localStorage.setItem(k, JSON.stringify(next))
    })
  } catch (err) {
    /* ignore */
  }
}

export function clearThemePropStorage(code) {
  const c = themePropCode(code)
  if (!c || typeof localStorage === 'undefined') return
  const exact = ['mainAttr', 'buZhang', 'fbLeader', 'height', 'relay', 'fbSub', 'fbConcepts']
  exact.forEach((kind) => {
    try {
      localStorage.removeItem(`${PREFIX[kind]}|${c}`)
    } catch (err) {
      /* ignore */
    }
  })
  const drop = []
  try {
    for (let i = 0; i < localStorage.length; i += 1) {
      const k = localStorage.key(i)
      if (!k) continue
      const relayDated = k.startsWith(`${PREFIX.relayV3}|`) && k.endsWith(`|${c}`)
      const fbPreselectDated = k.startsWith(`${PREFIX.fbPreselect}|`) && k.endsWith(`|${c}`)
      const fbChiDated = k.startsWith(`${PREFIX.fbPreselectChi}|`) && k.endsWith(`|${c}`)
      const relayOld = k.startsWith(`${PREFIX.relayV1}|`) && k.endsWith(`|${c}`)
      const heightOld = k.startsWith(`${PREFIX.heightV2}|`) && k.endsWith(`|${c}`)
      const heightOlder = k.startsWith(`${PREFIX.heightV1}|`) && k.includes(`|${c}|`)
      if (relayDated || fbPreselectDated || fbChiDated || relayOld || heightOld || heightOlder) drop.push(k)
    }
    drop.forEach((k) => localStorage.removeItem(k))
  } catch (err) {
    /* ignore */
  }
}

/** 仅当该日已经退池（exitDate <= 查看日）才清。查看退池前的日期不动。 */
export function clearThemePropForExited(items, tradeDate) {
  const td = String(tradeDate || '').trim()
  if (!td) return
  const seen = new Set()
  for (const item of items || []) {
    const exitDate = String((item && item.exitDate) || '').trim()
    if (!exitDate || exitDate > td) continue
    const code = themePropCode(item && (item.code || item.leaderId))
    if (!code || seen.has(code)) continue
    seen.add(code)
    clearThemePropStorage(code)
  }
}

/** 接力池 v2 只跟龙头。旧 key 带日期时，取该龙头最近一份非空名单迁过来。 */
export function readRelayMigrated(code) {
  const c = themePropCode(code)
  if (!c || typeof localStorage === 'undefined') return []
  const key = `${PREFIX.relay}|${c}`
  try {
    const raw = localStorage.getItem(key)
    if (raw) {
      const parsed = JSON.parse(raw)
      if (Array.isArray(parsed)) return parsed
    }
  } catch (err) {
    /* fall through */
  }
  let bestDate = ''
  let best = null
  try {
    for (let i = 0; i < localStorage.length; i += 1) {
      const k = localStorage.key(i)
      if (!k || !k.startsWith(`${PREFIX.relayV1}|`)) continue
      const parts = k.split('|')
      if (parts.length < 3 || themePropCode(parts[parts.length - 1]) !== c) continue
      const parsed = JSON.parse(localStorage.getItem(k) || '[]')
      if (!Array.isArray(parsed) || !parsed.length) continue
      const date = parts[1] || ''
      if (date >= bestDate) {
        bestDate = date
        best = parsed
      }
    }
  } catch (err) {
    best = null
  }
  if (best) {
    try {
      localStorage.setItem(key, JSON.stringify(best))
    } catch (err) {
      /* ignore */
    }
    return best
  }
  return []
}
